import { FC, ReactNode } from 'react'

import { GRAY_300, GRAY_900 } from 'constants/styling/theme'
import { IconButton, Typography } from '@mui/material'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import Stack from '@mui/material/Stack'

interface Props {
  /** File name to display */
  fileName: string
  /** Callback when download button is clicked */
  onDownload: () => void
  /** Custom file icon */
  icon?: ReactNode
}

/**
 * File row with download button for assignment detail drawer.
 * @example
 * <DetailFileAttachment fileName="floor_plan.pdf" onDownload={() => download(url)} />
 */
export const DetailFileAttachment: FC<Props> = ({ fileName, onDownload, icon }) => (
  <Stack
    direction="row"
    alignItems="center"
    gap="0.8rem"
    padding="0.8rem"
    border={`1px solid ${GRAY_300}`}
    borderRadius="0.8rem"
  >
    {icon ?? <DescriptionOutlinedIcon sx={{ color: GRAY_900, fontSize: '2rem' }} />}

    <Typography
      variant="text-sm"
      fontWeight={500}
      sx={{
        flex: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {fileName}
    </Typography>

    <IconButton size="small" onClick={onDownload}>
      <FileDownloadOutlinedIcon sx={{ color: GRAY_900, fontSize: '2rem' }} />
    </IconButton>
  </Stack>
)
